import { render, staticRenderFns } from "./MoreSubnavPanel.vue?vue&type=template&id=32df5fc8"
import script from "./MoreSubnavPanel.vue?vue&type=script&lang=js"
export * from "./MoreSubnavPanel.vue?vue&type=script&lang=js"
import style0 from "./MoreSubnavPanel.vue?vue&type=style&index=0&id=32df5fc8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports